/* eslint-disable */
export default {
  copy: 'Copier',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
